import { Component, OnInit } from '@angular/core';

import { FormBuilder, FormControl, FormGroup } from '@angular/forms';

import { ActivatedRoute, Router } from '@angular/router';

import { trigger, state, style, animate, transition } from '@angular/animations';

import { AccountService } from 'src/app/services/account.service';

import { OtherService } from 'src/app/services/other.service';

import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

import { DeviceDetectorService } from 'ngx-device-detector';

import { debounceTime, distinctUntilChanged, fromEvent, pluck } from 'rxjs';

import Swal from 'sweetalert2';

declare var bootstrap: any;

@Component({

  selector: 'app-taxilon-ads-detail',

  templateUrl: './taxilon-ads-detail.component.html',

  styleUrls: ['./taxilon-ads-detail.component.css'],

  animations: [
    trigger('slideInOut', [
      state(
        'open',
        style({
          height: '*',

          overflow: 'hidden',

          opacity: '1',

          margin: '10px 0',
        })
      ),

      state(
        'closed',
        style({
          height: '0',

          overflow: 'hidden',

          opacity: '0',
        })
      ),

      transition('open <=> closed', [animate('0.4s ease-in-out')]),
    ]),
  ],

})

export class TaxilonAdsDetailComponent implements OnInit {

  list_AdsImagesCounter: any;

  list_AdsImages: any = [];

  list_AdsImagesShown: any = [];

  information_ads: any = [];

  lst_Album: any[] = [];

  isLogin: boolean;

  isMobile: boolean = false;

  isAlbum: boolean = false;

  albumIndex: number = 0;

  mdl_Search: FormGroup = this.FormBuilder.group({

    iTaxiLon_User: new FormControl(0),

    strSession: new FormControl(''),

    iTaxilon_Advertisement: new FormControl(''),

    strSiteUrl: new FormControl(window.origin)

  })

  constructor(

    private _route: ActivatedRoute,

    private _router: Router,

    private FormBuilder: FormBuilder,

    private _otherService: OtherService,

    private _service: AccountService,

    private sanitizer: DomSanitizer,

    private deviceService: DeviceDetectorService,

  ) { }

  ngOnInit(): void {

    this.isMobile = this.deviceService.isMobile();

    this._route.paramMap.subscribe((params) => {

      this.mdl_Search.patchValue({

        iTaxiLon_User: this._otherService.getLocalStorage()?.Id ? this._otherService.getLocalStorage().Id : 0,

        strSession: this._otherService.getLocalStorage()?.session ? this._otherService.getLocalStorage().session : '',

        iTaxilon_Advertisement: params.get('id'),

      })

      this._otherService.setTitle(`امدادران | ${this.symbolTo_Space(params.get('title'))}`);

      this._service.get_AdsDetail_VS_Gallery(this._otherService.stringNumberToNumber(this.mdl_Search.value)).subscribe((data: any) => {

        let adsInfo = JSON.parse(data.adsInfo.toString());

        let gallery = JSON.parse(data.gallery.toString());

        let links = data.links;

        if (adsInfo?.bError) return this._router.navigate([`/jobs`]);

        if (gallery.bError) return this._service.toastSwal('error', gallery.strError);

        if (links.bError) return this._service.toastSwal('error', links.strError);

        this._otherService.setTitle(adsInfo.strSiteTitle);

        this.information_ads = { ...adsInfo, list_Gallery: gallery, lst_Links: links };

        this.list_AdsImagesCounter = this.information_ads.list_Gallery.length - (this.isMobile ? 2 : 3)

        this.list_AdsImagesShown = this.information_ads.list_Gallery.slice(0, (this.isMobile ? 2 : 3));

        //  ذخیره یادداشت اختصاصی

        setTimeout(() => {

          var textArea_Note = document.getElementById('textArea_');

          fromEvent(textArea_Note, 'keyup').pipe(debounceTime(1000), pluck('target', 'value'), distinctUntilChanged()).subscribe((data) => {

            var model_ = {

              ...this.mdl_Search.value,

              strComment: data

            };

            if (!this.isLogin) {

              this.showError();

            }

            else {

              this._service.Taxilon_Ads_Note(model_);

            }

          });

        }, 1000);

      })

      // check user login status

      this._otherService.isUserLogin$.subscribe((condition) => {

        this.isLogin = condition;

      });

    });

  }

  symbolTo_Space(title: string): string {

    return title?.trim().replace(/-/g, " ")

  }

  show_Warning_Before_Call() {

    Swal.fire({

      title: 'هشدار',

      text: 'هشدارهای لازم در خصوص عدم پرداخت هرگونه وجه و بررسی دقیق خودرو و خدمات را مشاهده نموده‌ام و نسبت به رعایت موارد امنیتی بر اساس قوانین و مقررات اجاره خودرو و استخدام راننده اقدام خواهم نمود',

      icon: 'warning',

      showCancelButton: false,

      showConfirmButton: true,

      showCloseButton: true,

      confirmButtonText: 'مشاهده اطلاعات تماس',

      confirmButtonColor: '#10B981',

    }).then((result) => {

      if (result.isConfirmed) this.getUser_Number();

    });

  }

  getUser_Number() {

    if (!this.isLogin) {

      Swal.fire({

        title: '',

        text: 'جهت مشاهده اطلاعات تماس، ابتدا وارد حساب کاربری خود شوید!',

        icon: 'warning',

        showCancelButton: true,

        showConfirmButton: true,

        showCloseButton: true,

        reverseButtons: true,

        confirmButtonText: 'ورود',

        cancelButtonText: 'بستن',

        confirmButtonColor: '#10B981',

      }).then((result) => {

        if (result.isConfirmed) {

          this._router.navigateByUrl(`taxilon/login/jobs`)

        }

      });

    }

    else {

      this._service.Taxilon_Ads_Number(this._otherService.stringNumberToNumber(this.mdl_Search.value)).subscribe((data) => {

        let res = JSON.parse(data.toString());

        if (res.bError) return this._service.toastSwal('error', res.strError);

        this.information_ads = { ...this.information_ads, strMobile: res.strMobile };

      });

    }

  }

  callWith_advertiser() {

    window.location.href = 'tel:' + this.information_ads.strMobile;

  }

  getSafeHtml(value: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(value);
  }

  shareVia() {
    if (navigator.share) {

      navigator
        .share({
          url: window.location.href,

          title: this.information_ads.strTitle,
        })
        .then(() => console.log('اشتراک گذاری موفق'))

        .catch(() =>
          this._service.toastSwal('error', 'متاسفانه خطایی رخ داده است')
        );
    } else
      this._service.toastSwal(
        'error',
        'قابلیت اشتراک گذاری برای شما پشتیبانی نمی شود'
      );
  }

  showError() {

    return Swal.fire({

      title: '',

      text: 'جهت ذخیره یادداشت، ابتدا وارد حساب کاربری خود شوید!',

      icon: 'warning',

      showCancelButton: true,

      showConfirmButton: true,

      showCloseButton: true,

      reverseButtons: true,

      confirmButtonText: 'ورود',

      cancelButtonText: 'بستن',

      confirmButtonColor: '#10B981',

    }).then((result) => {

      if (result.isConfirmed) {

        this._router.navigateByUrl(`taxilon/login/jobs`)

      }

    });

  }

  openGallery(item: any, index?: number) {

    // this.lst_Album = [];

    // this.information_ads.list_Gallery.forEach((el: any) => {

    //   this.lst_Album.push(el);

    // })

    this.lst_Album = this.information_ads.list_Gallery;

    this.isAlbum = false;

    this.albumIndex = this.lst_Album.indexOf(item);

    setTimeout(() => {

      this.isAlbum = true;

    }, 20);

    var myModal = new bootstrap.Modal(document.getElementById('galleryComp_Modal'), {});

    myModal.show();

  }

  goTo_Support() {

    if (!this.isLogin) {

      Swal.fire({

        title: '',

        text: '!جهت ثبت گزارش، ابتدا وارد حساب کاربری خود شوید',

        icon: 'warning',

        showCancelButton: true,

        showConfirmButton: true,

        showCloseButton: true,

        reverseButtons: true,

        confirmButtonText: 'ورود',

        cancelButtonText: 'بستن',

        confirmButtonColor: '#10B981',

      }).then((result) => {

        if (result.isConfirmed) {

          this._router.navigateByUrl(`taxilon/login/jobs`)

        }

      });

    }

    else {
      this._router.navigateByUrl(`/Support`)

    }

  }


}
